const actions = {
    page_title: 'Actions',
    title: 'Actions',
    subtitle: 'เรียกใช้โค้ดที่กำหนดเอง ณ จุดที่ระบุในขั้นตอนการยืนยันตัวตน เพื่อขยายการทำงานของ Logto',
    status: {
        not_configured: 'ยังไม่ได้กำหนดค่า',
        configured: 'กำหนดค่าแล้ว',
        enabled: 'เปิดใช้งาน',
        disabled: 'ปิดใช้งาน',
    },
    types: {
        post_first_factor_verification: {
            name: 'หลังจากยืนยันปัจจัยแรก',
            description: 'เรียกใช้ตรรกะที่กำหนดเองหลังจากการตรวจสอบรหัสผ่านภายในล้มเหลวระหว่างการเข้าสู่ระบบ',
        },
        post_sign_in: {
            name: 'หลังจากเข้าสู่ระบบ',
            description: 'เรียกใช้ตรรกะที่กำหนดเองหลังจากผู้ใช้เข้าสู่ระบบสำเร็จ',
        },
    },
    data_source_tab: 'แหล่งข้อมูล',
    test_tab: 'บริบทการทดสอบ',
    settings_tab: 'การตั้งค่า',
    event_data: {
        title: 'เพย์โหลดเหตุการณ์',
        subtitle: 'ใช้พารามิเตอร์อินพุต `event` สำหรับข้อมูลเหตุการณ์การยืนยันตัวตน',
    },
    result_data: {
        title: 'ผลลัพธ์ของการดำเนินการ',
        subtitle: 'ส่งคืนอ็อบเจกต์ผลลัพธ์ที่ Logto เข้าใจสำหรับการดำเนินการประเภทนี้',
    },
    environment_variables: {
        title: 'ตั้งค่าตัวแปรสภาพแวดล้อม',
        subtitle: 'ใช้ตัวแปรสภาพแวดล้อมเพื่อเก็บข้อมูลที่ละเอียดอ่อน',
        input_field_title: 'เพิ่มตัวแปรสภาพแวดล้อม',
        sample_code: 'การเข้าถึงตัวแปรสภาพแวดล้อมในตัวจัดการการดำเนินการ ตัวอย่าง:',
    },
    fetch_external_data: {
        title: 'ดึงข้อมูลภายนอก',
        subtitle: 'เรียก API ภายนอกจากสคริปต์การดำเนินการของคุณ',
        description: 'ใช้ฟังก์ชัน `fetch` เพื่อเรียก API ภายนอกของคุณและรวมข้อมูลไว้ในผลลัพธ์ของการดำเนินการ ตัวอย่าง:',
    },
    settings: {
        title: 'การตั้งค่า',
        subtitle: 'ควบคุมว่าจะเปิดใช้งานการดำเนินการหรือไม่ และจะจัดการข้อผิดพลาดตอนรันไทม์อย่างไร',
        enabled: {
            title: 'เปิดใช้งานการดำเนินการ',
            description: 'เรียกใช้สคริปต์นี้เมื่อมีการทริกเกอร์เหตุการณ์การยืนยันตัวตน',
        },
        on_execution_error: {
            title: 'เมื่อสคริปต์เกิดข้อผิดพลาด',
            description: 'เลือกพฤติกรรมของ Logto เมื่อสคริปต์ล้มเหลวตอนรันไทม์',
            block: 'บล็อกขั้นตอนการยืนยันตัวตน',
            allow: 'อนุญาตให้ขั้นตอนการยืนยันตัวตนดำเนินต่อ',
            post_first_factor_description: 'เมื่อสคริปต์นี้ล้มเหลว Logto จะปฏิเสธข้อมูลรับรองที่ไม่ถูกต้องเสมอ เพื่อไม่ให้สามารถข้ามการตรวจสอบรหัสผ่านได้',
        },
    },
    test_context: {
        subtitle: 'ปรับเพย์โหลดเหตุการณ์จำลองที่ใช้เมื่อรันการทดสอบ',
        input_field_title: 'JSON ตัวอย่างเหตุการณ์',
    },
    script: {
        title: 'สคริปต์',
        restore: 'คืนค่าเริ่มต้น',
        restored: 'คืนค่าแล้ว',
    },
    tester: {
        run_button: 'รันการทดสอบ',
        result_title: 'ผลการทดสอบ',
    },
    form_error: {
        invalid_json: 'รูปแบบ JSON ไม่ถูกต้อง',
    },
    security_warning: {
        title: 'คำเตือนด้านความปลอดภัย',
        description: 'การดำเนินการนี้จะทำงานหลังจากการตรวจสอบรหัสผ่านภายในล้มเหลวเท่านั้น ส่งคืน `passwordVerified: true` หลังจากตรวจสอบรหัสผ่านที่ส่งมาอย่างอิสระแล้วเท่านั้น ผู้ใช้ที่จัดเตรียมโดยการดำเนินการนี้จะข้ามการป้องกันเฉพาะการลงทะเบียน รวมถึงรายการบล็อกอีเมล โดเมนเฉพาะ SSO โหมดปิดการสมัครใช้งาน และการตรวจสอบโปรไฟล์บังคับตอนลงทะเบียน การเขียนโปรไฟล์และรหัสผ่านของผู้ใช้ที่มีอยู่ก็เกิดขึ้นก่อนที่ MFA จะเสร็จสมบูรณ์เช่นกัน',
    },
    delete_modal_title: 'ลบการดำเนินการ',
    delete_modal_content: 'คุณแน่ใจหรือไม่ว่าต้องการลบการดำเนินการนี้ ขั้นตอนการยืนยันตัวตนจะไม่รันสคริปต์นี้อีกต่อไป',
    deleted: 'ลบการดำเนินการแล้ว',
    created: 'สร้างการดำเนินการแล้ว',
    saved: 'บันทึกการดำเนินการแล้ว',
};
export default Object.freeze(actions);
